<template>
  <div class="custom-form" v-if="content">
    <div v-html="content.code"></div>
  </div>
</template>

<script>
export default {
  props: {
    content: null
  },
  methods: {},
  mounted() {
    var script_tag = document.createElement("script");
    script_tag.type = "text/javascript";
    script_tag.text = this.content.script;
    document.body.appendChild(script_tag);

    var sib = document.createElement("script");
    sib.src = "https://sibforms.com/forms/end-form/build/main.js";
    document.body.appendChild(sib);
  }
};
</script>

<style lang="scss"></style>
